export function waitForElement(
  selector: string,
  timeout = 5000
): Promise<Element | null> {
  return new Promise((resolve) => {
    const immediate = document.querySelector(selector);
    if (immediate) {
      resolve(immediate);
      return;
    }
    let observer: MutationObserver | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    const cleanup = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };

    observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        cleanup();
        resolve(el);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    timeoutId = setTimeout(() => {
      cleanup();
      resolve(null);
    }, timeout);
  });
}
